import env from '@/config/environment';
import { GraphQlMethods, gqlFetch } from '../../api/core/fetch';

type GetStrapiParams<Variables> = Variables extends undefined
  ? { id: string; query: string; variables?: never }
  : {
      id: string;
      query: string;
      variables: Variables;
    };

export function getStrapi<Variables, Response>({
  id,
  query,
  variables,
}: GetStrapiParams<Variables>) {
  return gqlFetch<Variables, Response>({
    id,
    baseUrl: env.PUBLIC_STRAPI_URL,
    method: GraphQlMethods.Get,
    query,
    variables,
    extraHeader: {
      Authorization: `Bearer ${env.PUBLIC_STRAPI_TOKEN}`,
    },
  });
}
